import { useQuery } from '@tanstack/react-query';
import apiClient from '../../../api/client';
import type { CatalogoResponse, Paginated } from '@aid/shared';

interface UseCatalogosOptions {
  limit?: number;
  parentId?: number;
  active?: boolean;
  enabled?: boolean;
}

export function useCatalogos(category: string, options?: UseCatalogosOptions) {
  const limit = options?.limit ?? 100;
  const active = options?.active ?? true;
  const parentId = options?.parentId;
  return useQuery({
    queryKey: ['catalogos', category, { limit, parentId, active }],
    queryFn: async () => {
      const { data } = await apiClient.get<Paginated<CatalogoResponse>>('/admin/catalogos', {
        params: { category, limit, parentId, active },
      });
      return data.data;
    },
    enabled: options?.enabled ?? true,
    staleTime: 300_000,
  });
}

export function usePlanesList(search?: string) {
  return useQuery({
    queryKey: ['planes', { search }],
    queryFn: async () => {
      const { data } = await apiClient.get<Paginated<import('@aid/shared').PlanResponse>>(
        '/admin/planes',
        { params: { limit: 100, offset: 0, search } },
      );
      return data.data;
    },
    staleTime: 300_000,
  });
}

export function useTiposServicioList(search?: string) {
  return useQuery({
    queryKey: ['tipos-servicio', { search }],
    queryFn: async () => {
      const { data } = await apiClient.get<Paginated<import('@aid/shared').TipoServicioResponse>>(
        '/admin/tipos-servicio',
        { params: { limit: 100, offset: 0, search } },
      );
      return data.data;
    },
    staleTime: 300_000,
  });
}
